// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"56c766a6","197":"f244e762","318":"3fe2a708","640":"271f523f","709":"573d6bd7","746":"3caf22cc","769":"18f8ae47","852":"a5d49dfd","879":"f377e144","996":"2a63f04a"}[chunkId] + ".css";
};